'use client';

import { createContext, useContext } from 'react';

export type EmbedModule = 'space-manager' | 'events' | 'membership';

export interface EmbedContextValue {
    /** True only inside an /iframe/* page. Every consumer must keep its non-embed behaviour on false. */
    isEmbed: boolean;
    clubSlug?: string;
    module?: EmbedModule;
    /**
     * Frame id handed over by public/embed.js via ?_sid=. Present only when the page was
     * created by the loader script, which is also what tells us the parent can auto-resize.
     */
    frameId?: string;
}

export const EmbedContext = createContext<EmbedContextValue>({ isEmbed: false });

/** Read the embed state. Returns { isEmbed: false } outside of an embed, so callers stay unchanged. */
export const useEmbed = (): EmbedContextValue => useContext(EmbedContext);

/** True when the frame was rendered by the embed loader script (and therefore auto-resizes). */
export const useHasEmbedLoader = (): boolean => !!useEmbed().frameId;
